/**
 * @file
 * Search toggle script.
 */

(function searchToggleScript($, Drupal, once) {
  'use strict';

  let windowWidth = 0;

  function isHiddenPersistent($element) {
    return $element.length > 0 && $element[0].hasAttribute('data-hidden-persistent');
  }

  function show($element) {
    $element
      .removeClass('hidden--important')
      .attr('aria-hidden', 'false');
    return $element;
  }

  function hide($element) {
    $element
      .addClass('hidden--important')
      .attr('aria-hidden', 'true');
    return $element;
  }

  function getTarget(toggle) {
    const $toggle = $(toggle);
    let $target = [];

    const targetEl = $toggle.data('searchToggleTargetElement');
    if (typeof targetEl !== 'undefined' && targetEl !== null) {
      // Use stored element.
      $target = $(targetEl);
    } else {
      // Find the target.
      const searchTargetClass = $toggle.data('searchToggleTarget');
      if (typeof searchTargetClass !== 'undefined' && searchTargetClass !== null) {
        $target = $(`.${searchTargetClass}`).first();
        if ($target.length > 0) {
          $toggle.data('searchToggleTargetElement', $target[0]);
        }
      }
    }

    return $target;
  }

  function closeLinkClickKeydownListener(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.type === 'keydown' &&
        // Key is not Enter or Space.
        (event.key !== 'Enter' && event.key !== ' ')) {
      return;
    }

    const closeLink = event.currentTarget;
    const toggleLink = $(closeLink).data('searchToggleLink');
    if (typeof toggleLink !== 'undefined' && toggleLink) {
      const $toggle = $(toggleLink);
      const $target = getTarget(toggleLink);
      if ($toggle.length > 0 && $target.length > 0) {
        /* eslint-disable no-use-before-define */
        collapse($toggle, $target);
        /* eslint-enable no-use-before-define */
        $toggle.parents('.search-toggles-block').removeClass('is-active');
      }
    }

    closeLink.classList.add('hidden');
  }

  /**
   * Create or get the close link.
   *
   * @param {HTMLElement|jQuery} toggleLink
   *   The toggle link.
   *
   * @return {jQuery}
   *  The jQuery for ".search-toggle-link__close".
   */
  function getCloseLink(toggleLink) {
    const $toggleLink = $(toggleLink);
    if ($toggleLink.length === 0) {
      return $([]);
    }

    // Use the stored close link if it exist.
    const storedClose = $toggleLink.data('searchToggleCloseLink');
    if (typeof storedClose !== 'undefined' && storedClose !== null) {
      const $storedClose = $(storedClose);
      if ($storedClose.length > 0) {
        return $storedClose;
      }
    }

    const text = $toggleLink.data('closeLinkText');
    let context = $toggleLink.data('closeLinkContext');
    let $close;

    // No text means no link.
    if (typeof text === 'undefined' || !text) {
      return $([]);
    }

    // Set a default context.
    if (typeof context === 'undefined') {
      context = '.page__sidebar-first--inner';
    }
    const $context = $(context);
    if ($context.length === 0) {
      return $([]);
    }

    $close = $context.find('.search-toggle-link__close');
    if ($close.length > 0) {
      return $close;
    }

    // Create the close link.
    $close = $(`<div class="search-toggle-link__close"><button class="search-toggle-link__close-link">${text}</button></div>`);

    // Store the references to each other.
    $close.data('searchToggleLink', toggleLink);
    $toggleLink.data('searchToggleCloseLink', $close.get(0));

    // Click handler.
    $(once('searchToggleLinkCloseOnClick', $close)).on('click keydown', closeLinkClickKeydownListener);

    // Append to the context.
    $close.appendTo($context.first());

    return $close;
  }

  function expandTarget($target) {
    show($target)
      .addClass('expanded');
  }

  function expand($toggle, $target) {
    $toggle.attr('aria-expanded', 'true');
    $toggle.parents('.search-toggles-block').addClass('is-active');
    expandTarget($target);
    getCloseLink($toggle).removeClass('hidden');
  }

  function collapseTarget($target) {
    hide($target)
      .removeClass('expanded');
  }

  function collapse($toggle, $target) {
    $toggle.attr('aria-expanded', 'false');
    collapseTarget($target);
    getCloseLink($toggle).addClass('hidden');
  }

  function setWindowWidth() {
    windowWidth = $(window).width();
  }

  function setVisibility($toggle) {
    const noBreakpoint = $toggle.data('searchToggleNoBreakpoint') === true;
    if (!windowWidth) {
      setWindowWidth();
    }

    const $target = getTarget($toggle);
    if (isHiddenPersistent($target)) {
      hide($toggle);
      return;
    }

    // 1600px($bp--xxxlarge) - 256px($vert-nav--width) = 1344
    if (!noBreakpoint && windowWidth >= 1344) {
      // Above the breakpoint: Hide toggle, show target.
      // Expand target if not already expanded.
      hide($toggle)
        .prop('disabled', true);
      show($target)
        .removeClass('expanded');
    } else {
      // Show toggle.
      show($toggle)
        .prop('disabled', false);
      // Determine if the target should be shown.
      const isExpanded = $toggle.attr('aria-expanded');
      if (typeof isExpanded === 'undefined' || isExpanded === 'false') {
        // Collapse target.
        collapseTarget($target);
      } else {
        // Expand target.
        expandTarget($target);
      }
    }
  }

  function toggleElements(toggle) {
    const $toggle = $(toggle);
    const $target = getTarget(toggle);

    if ($target.length > 0) {
      if (isHiddenPersistent($target)) {
        hide($toggle);
        return;
      }

      // This is zero if the searchTarget is hidden.
      if (!$target.hasClass('expanded')) {
        // Expand.
        expand($toggle, $target);

        const $otherToggles = $toggle.parent().siblings().find('.js-search-toggle');
        $otherToggles.get().forEach((otherToggle) => {
          const $otherToggle = $(otherToggle);
          const $otherTarget = getTarget(otherToggle);
          collapse($otherToggle, $otherTarget);
        });

        Drupal.ahsThemeSite.scrollTop($target, { topBuffer: 200 });
      } else {
        // Collapse.
        collapse($toggle, $target);
        // Remove is-active when no other toggles are expanded.
        $toggle.parents('.search-toggles-block').removeClass('is-active');
      }
    }
  }

  function toggleClickListener(event) {
    event.preventDefault();
    event.stopPropagation();
    toggleElements(event.currentTarget);
  }

  function toggleKeydownListener(event) {
    // Handle 'space' key.
    if (event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
      toggleElements(event.currentTarget);
    }
  }

  function intializeToggle(toggle) {
    const $toggle = $(toggle);
    const searchTargetClass = $toggle.attr('data-search-toggle-target');
    if (typeof searchTargetClass === 'undefined') {
      return;
    }

    const $target = getTarget($toggle);
    if ($target.length === 0) {
      return;
    }

    // Toggle must have an ID.
    const toggleId = $toggle.attr('id');
    if (typeof toggleId === 'undefined' || !toggleId) {
      return;
    }

    // Ensure that the target has an ID.
    let targetId = $target.attr('id');
    if (typeof targetId === 'undefined' || !targetId) {
      targetId = `search-target-${toggleId}`;
      $target.attr('id', targetId);
    }

    if ($target.is('.physicians-search-results-form--hidden')) {
      $toggle.hide();
      return;
    }

    $toggle.attr('aria-controls', targetId);

    $target.attr('tabindex', '-1');
    $target.attr('aria-labelledby', toggleId);

    setVisibility($toggle);

    if (once('searchToggleScriptClick', 'html').length) {
      $(window).resize(Drupal.ahsThemeSite.debounce(() => {
        setWindowWidth();
        document.querySelectorAll('.js-search-toggle').forEach((resizeToggle) => {
          setVisibility($(resizeToggle), true);
        });
      }, 500));
    }

    $(once('searchToggleScriptClick', $toggle))
      .on('click', toggleClickListener)
      .on('keydown', toggleKeydownListener);
  }

  Drupal.behaviors.themeSearchToggle = {
    attach(context) {
      // Search toggles.
      const toggles = once('themeSearchToggleScriptBehaviors', '.js-search-toggle', context);
      if (!toggles.length) {
        return;
      }

      toggles.forEach((toggle) => {
        intializeToggle(toggle);
      });
    },
  };
}(jQuery, Drupal, once));
